export const proposals = [
  {
    title: "E-Commerce Platform Modernization",
    description: "A high-level Scrum Master/PM proposal for modernizing an e-commerce platform.",
    url: "https://docs.google.com/document/d/your-doc-id-1/preview",
    duration: "12 weeks",
    technology: "React, Node.js, AWS, MongoDB",
    problem: "Legacy system with slow performance and poor scalability.",
    solution: "Re-architect with microservices, CI/CD, and cloud-native best practices.",
  },
  // Add more proposals as needed
];
